import React, {useEffect} from 'react';
import {CF} from 'module/CustomField/util/CustomField';
import {CFComponentProps} from 'module/CustomField/type/CFComponentType';
import {CFValue} from 'module/CustomField/type/CFType';
import {KostSelectComponent} from 'module/Kost/component/KostSelectComponent'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {selKostVisibleIds} from 'module/Kost/selector/KostSelector'
import {useSelector} from 'react-redux'
import {getMemoSelectedSize} from 'module/Memo/util/MemoUtil'

export function CustomFieldKostSelectComponent(props: CFComponentProps<CFValue>) {
	const {cfDef, setCb, model, disabled, placeholderHTML, pos} = props
	const value = CF.getValueFrom(cfDef, model, {pos})
	const showOnlyVisible = CF.getCFAttr(cfDef, CFAttrKey.showOnlyVisible)?.value !== 'N'
	const visibleKostkeys = useSelector(selKostVisibleIds)
	const sfv = CF.getCFAttr(cfDef, CFAttrKey.selectFirstVisible)?.value
	const selectFirstVisible = visibleKostkeys.length < 2 && sfv !== 'N' || sfv === 'J'
	const firstVisibleKost = visibleKostkeys[0]
	useEffect(() => {
		if (selectFirstVisible && !value && firstVisibleKost) {
			setCb(firstVisibleKost)
		}
	}, []);
	return (
		<div className={'CustomFieldKostSelectComponent'}>
			<KostSelectComponent
				kostkey={value as string}
				onChange={setCb}
				disabled={disabled}
				placeholderHTML={placeholderHTML}
				showOnlyVisible={showOnlyVisible}
				memoSize={getMemoSelectedSize(cfDef)}
			/>
		</div>
	)
}